 
import PropertyBreadcrumb from "../../commonComponents/breadcrumbs/PropertyBreadcrumb";
import SortBy from "../../commonComponents/SortBy";
import GridView from "../../commonComponents/gridView";

const MapListContainer = () => {
  return (
    <>
      <PropertyBreadcrumb />
      <SortBy />
      <GridView type="property" sectionClass="section-b-space property-list property-inner-section" side="no" gridType="list-view" map gridSize={1} carShow={4} />
    </>
  );
};

export default MapListContainer;
